// pages/AdminLogin.js
import AdminLoginPage from "../components/RegisterScreen/AdminLoginForm";

const AdminLogin = () => {
  return (
    <>
      <AdminLoginPage />
    </>
  );
}
export default AdminLogin;
